// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jogos-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.jogos-header {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.jogos-header h1 {
  margin: 0 0 8px 0;
  font-size: 28px;
  color: #1a1a1a;
  font-weight: 700;
}

.jogos-header .subtitulo {
  margin: 0;
  font-size: 14px;
  color: #666;
}

/* Seletor de Modo */
.modo-selector {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  justify-content: center;
}

.btn-modo {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #666;
}

.btn-modo:hover {
  border-color: #2196f3;
  color: #2196f3;
}

.btn-modo.ativo {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  color: white;
  border-color: #1976d2;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
}

.btn-modo .icon {
  font-size: 18px;
}

/* Seletor de Grupos */
.grupo-selector {
  margin-bottom: 20px;
  background: white;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.grupos-scroll {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 4px 0;
  -webkit-overflow-scrolling: touch;
}

.grupos-scroll::-webkit-scrollbar {
  height: 4px;
}

.grupos-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.grupos-scroll::-webkit-scrollbar-thumb {
  background: #2196f3;
  border-radius: 4px;
}

.btn-grupo {
  padding: 8px 16px;
  background: #f5f5f5;
  border: 2px solid transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
}

.btn-grupo:hover {
  background: #e8e8e8;
  border-color: #2196f3;
  color: #2196f3;
}

.btn-grupo.ativo {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  color: white;
  border-color: #1976d2;
}

.btn-grupo .qtd-jogos {
  background: rgba(255, 255, 255, 0.3);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
}

/* Lista de Jogos */
.jogos-lista {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.jogos-info {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.jogos-info p {
  margin: 0;
  font-size: 13px;
  color: #666;
  font-weight: 500;
}

.sem-jogos {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}

.sem-jogos p {
  margin: 0;
  font-size: 14px;
}

/* Estados de Carregamento e Erro */
.carregando,
.erro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  background: white;
  border-radius: 8px;
  padding: 40px 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2196f3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.carregando p,
.erro p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.erro {
  background: #fff3cd;
  border: 1px solid #ffc107;
}

.erro p {
  color: #856404;
  margin-bottom: 16px;
}

.btn-tentar-novamente {
  padding: 10px 24px;
  background: #2196f3;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-tentar-novamente:hover {
  background: #1976d2;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
}

/* Responsivo */
@media (max-width: 600px) {
  .jogos-container {
    padding: 12px;
  }

  .jogos-header {
    padding: 16px;
    margin-bottom: 20px;
  }

  .jogos-header h1 {
    font-size: 22px;
  }

  .modo-selector {
    flex-direction: column;
    gap: 8px;
  }

  .btn-modo {
    width: 100%;
    justify-content: center;
  }

  .jogos-lista {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/paginas/Jogos.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,mCAAmC;AACnC;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".jogos-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n}\n\n.jogos-header {\n  text-align: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.jogos-header h1 {\n  margin: 0 0 8px 0;\n  font-size: 28px;\n  color: #1a1a1a;\n  font-weight: 700;\n}\n\n.jogos-header .subtitulo {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n}\n\n/* Seletor de Modo */\n.modo-selector {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n  justify-content: center;\n}\n\n.btn-modo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #666;\n}\n\n.btn-modo:hover {\n  border-color: #2196f3;\n  color: #2196f3;\n}\n\n.btn-modo.ativo {\n  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n  color: white;\n  border-color: #1976d2;\n  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);\n}\n\n.btn-modo .icon {\n  font-size: 18px;\n}\n\n/* Seletor de Grupos */\n.grupo-selector {\n  margin-bottom: 20px;\n  background: white;\n  border-radius: 8px;\n  padding: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.grupos-scroll {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  padding: 4px 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.grupos-scroll::-webkit-scrollbar {\n  height: 4px;\n}\n\n.grupos-scroll::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.grupos-scroll::-webkit-scrollbar-thumb {\n  background: #2196f3;\n  border-radius: 4px;\n}\n\n.btn-grupo {\n  padding: 8px 16px;\n  background: #f5f5f5;\n  border: 2px solid transparent;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #666;\n}\n\n.btn-grupo:hover {\n  background: #e8e8e8;\n  border-color: #2196f3;\n  color: #2196f3;\n}\n\n.btn-grupo.ativo {\n  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n  color: white;\n  border-color: #1976d2;\n}\n\n.btn-grupo .qtd-jogos {\n  background: rgba(255, 255, 255, 0.3);\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n/* Lista de Jogos */\n.jogos-lista {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.jogos-info {\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.jogos-info p {\n  margin: 0;\n  font-size: 13px;\n  color: #666;\n  font-weight: 500;\n}\n\n.sem-jogos {\n  text-align: center;\n  padding: 40px 20px;\n  color: #999;\n}\n\n.sem-jogos p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Estados de Carregamento e Erro */\n.carregando,\n.erro {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  background: white;\n  border-radius: 8px;\n  padding: 40px 20px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #2196f3;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.carregando p,\n.erro p {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.erro {\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n}\n\n.erro p {\n  color: #856404;\n  margin-bottom: 16px;\n}\n\n.btn-tentar-novamente {\n  padding: 10px 24px;\n  background: #2196f3;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-tentar-novamente:hover {\n  background: #1976d2;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);\n}\n\n/* Responsivo */\n@media (max-width: 600px) {\n  .jogos-container {\n    padding: 12px;\n  }\n\n  .jogos-header {\n    padding: 16px;\n    margin-bottom: 20px;\n  }\n\n  .jogos-header h1 {\n    font-size: 22px;\n  }\n\n  .modo-selector {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .btn-modo {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .jogos-lista {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
